import Stack from '@mui/material/Stack';
import { ReviewsList /*GameReview*/ } from '../../reviews/ReviewsList';
import { ArticlesList } from '../../reviews/ArticlesList';
//import { ArticleCardProps } from '../../reviews/ArticleListItem';
import { useEffect, useState } from 'react';
import { firestore } from 'src/config/firebaseClient';
import { getDocs, collection } from 'firebase/firestore';
import { Game } from 'functions/src/types/firestore/Game';
import { Review } from 'functions/src/types/firestore/Game/Review';
import { Article } from 'functions/src/types/firestore/Game/Article';
import { useMobile } from 'src/hooks/useMobile';
import Box from '@mui/material/Box';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';
import { LottieLoader } from 'src/components/LottieLoader';

const getRecommendationLevel = (reviews: Review<Date>[]) => {
  const recommended = reviews.filter((review) => review.recommended).length;
  const proportion = recommended / reviews.length;
  if (proportion > 0.8) {
    return 'HIGHLY RECOMMENDED';
  }
  if (proportion > 0.5) {
    return 'RECOMMENDED';
  }
  return 'MIXED';
};

type ReviewsTabProps = Pick<Game, 'id'>;

export const ReviewsTab = ({ id }: ReviewsTabProps) => {
  const isMobile = useMobile();

  const [articles, setArticles] = useState<Article<Date>[]>([]);
  const [reviews, setReviews] = useState<Review<Date>[]>([]);
  useEffect(() => {
    const handler = async () => {
      const reviewDocs = await getDocs(
        collection(firestore, `Game/${id}/Review`).withConverter(
          ConverterFactory.buildDateConverter<Review<Date>>(),
        ),
      );
      const articleDocs = await getDocs(
        collection(firestore, `Game/${id}/Article`).withConverter(
          ConverterFactory.buildDateConverter<Article<Date>>(),
        ),
      );
      setReviews(reviewDocs.docs.map((doc) => doc.data()));
      setArticles(articleDocs.docs.map((doc) => doc.data()));
    };
    handler();
  }, [id]);

  if (reviews.length === 0 && articles.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <LottieLoader sx={{ height: '40px', width: '40px' }} />
      </Box>
    );
  }
  return (
    <>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        justifyContent="center"
        alignItems="flex-start"
        gap="32px"
        sx={{ mx: 3 }}
      >
        {!!articles && <ArticlesList articles={articles} />}
        {!!reviews && (
          <ReviewsList
            recommendationLevel={getRecommendationLevel(reviews)}
            reviews={reviews}
          />
        )}
      </Stack>
    </>
  );
};
